import { useMemo, useState } from "react"
import { Button, DialogActions, DialogContent, Modal } from "@mui/material"

import { BootstrapDialog, BootstrapDialogTitle } from "../../utils/bootstrapDialog";

import { SessionParamsEnum } from "../../../enums";
import { useSessionParams } from "../../../contexts";
import { FindSessionOnFB } from "../../utils/findSessionOnFB";

export const MainOutdatedVersionModal = () => {
    const sessionParams = useSessionParams();

    const [isEdit, setIsEdit] = useState(false);
    const [openEdit, setOpenEdit] = useState(false);
    const handleCloseEdit = () => setOpenEdit(false);

    const openModal = useMemo(() => {
        if (SessionParamsEnum.OldVersionModal.getContextValue(sessionParams) === true) {
            return true;
        }
        else {
            return false;
        }
    }, [SessionParamsEnum.OldVersionModal.getContextValue(sessionParams)])

    const handleModalClose = () => {
        SessionParamsEnum.OldVersionModal.setContextValue(sessionParams, false);
    }

    const openNewSession = () => {
        setIsEdit(true);
        setOpenEdit(true);
    }

    return (
        <>
            <BootstrapDialog
                aria-labelledby="add-addon-modal"
                open={openModal}
            >
                <BootstrapDialogTitle onClose={handleModalClose}>
                    Sessionen skapades i en äldre version
                </BootstrapDialogTitle>

                <DialogContent sx={{ width: '500px' }} dividers>
                    <p>
                        Den ursprungliga sessionen skapades i en äldre version av ShuntLogik utan hantering av
                        systemvätska. Om du väljer att gå vidare kommer:
                    </p>

                    <ul>
                        <li>
                            Alla positioner med tidigare fritextvärde för systemvätska på Pump-fliken få
                            Systemvätska: Annan och tidigare manuellt angiven systemvätska fortsatt synas i
                            specifikationen.
                        </li>
                        <li>
                            Alla positioner utan tidigare fritextvärde för systemvätska få Systemvätska: Vet ej/inte
                            fastställt.
                        </li>
                    </ul>

                    <p>
                        Inga beräkningar behöver göras om, men om funktionalitet relaterad till systemvätska
                        önskar användas behöver detta sättas på Parameter-fliken och beräkning utföras på nytt.
                    </p>
                </DialogContent>

                <DialogActions>
                    <Button variant="outlined" onClick={handleModalClose}>Gå vidare</Button>
                </DialogActions>
            </BootstrapDialog>

            {openModal ? (
                <Modal
                    open={openEdit}
                    onClose={handleCloseEdit}
                >
                    <div>
                        <FindSessionOnFB sessionID={SessionParamsEnum.SessionID.getContextValue(sessionParams)} edit={isEdit} viaOutdatedModal={true} />
                    </div>
                </Modal>
            ) : ("")}
        </>
    )
}